module.exports = __webpack_public_path__ + "img/Character_Yanfei_Thumb.05cc238f.png";